import {BooleanCheckbox, Link, Typography} from "@sgi/gravity";
import React from "react";

export default function Terms({ isTOUed, setIsTOUed } : {
  readonly isTOUed: boolean;
  readonly setIsTOUed: React.Dispatch<React.SetStateAction<boolean>>;
}) {
  return (
    <>
      <BooleanCheckbox
        name="touAgreement"
        data-testid="touAgreement-test"
        value={isTOUed}
        onChange={(e: any) => setIsTOUed(!isTOUed)}
        marginTop="10px"
        marginBottom="25px"
      >
        I agree to SGI's{" "}
        <Link
          href="https://www.mysgi.ca/help_pages/terms_and_conditions.html"
          isExternal={true}
          data-testid="tou-link-test"
        >
          Terms of Use
        </Link>{" "}
        and{" "}
        <Link
          href="https://sgi.sk.ca/privacy"
          isExternal={true}
          data-testid="cal-link-test"
        >
          Privacy Statement
        </Link>
      </BooleanCheckbox>
      <Typography fontWeight={"bold"} variant="body" >
      Please note by registering for this portal, you will be receiving portal notifications but you can unsubscribe at any time, though this may affect your ability to use the services provided through the portal.
      </Typography>
    </>
  );
}